import { render, staticRenderFns } from "./LessonReservationButton.vue?vue&type=template&id=21534af4&"
import script from "./LessonReservationButton.vue?vue&type=script&lang=ts&"
export * from "./LessonReservationButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports